export const PackagePlans = [
    {
        type : 'basic',
        perks: [
            "Up to 2 responsive pages",
            "1 months maintenance included",
            "Standard branding",
            "Contact form integration",
            "Basic SEO optimization",
            "website hosting"
        ]
    },
    {
        type : 'standard',
        perks: [
            "Up to 4 responsive pages",
            "2 months maintenance included",
            "Enhanced branding",
            "Custom design features",
            "Advanced SEO optimization",
            "Blog setup with CMS",
            "Google Analytics integration",
            "website hosting"
        ]
    },
    {
        type : 'pro',
        perks: [
            "Up to 6 responsive pages",
            "3 months maintenance included",
            "Premium branding",
            "E-commerce functionality with payment gateway integration",
            "Social media integration",
            "Advanced analytics dashboard",
            "website hosting"
        ]
    },
    {
        type : 'custom',
        perks: [
            "Tailored to meet your unique business needs",
            "Custom number of pages",
            "Custom maintenance duration",
            "Custom branding solutions",
            "Bespoke design and development",
            "API integrations",
            "Dedicated account manager",
            "website hosting"
        ]
    }
]

